/* eslint-disable max-classes-per-file */
import {
  Grid, Link, Typography,
} from '@mui/material';
import { useMemo, useState } from 'react';
import BlockProps from '../../../models/BlockProps';
import BlockData from '../../../models/BlockData';
import LinkData from '../../../models/LinkData';
import Utils from '../../../utils/Utils';
import CloseButton from '../../Buttons/Close';
import EditableText from '../../Form/EditableText';
import BlockFooterData from './BlockFooterData';
import BlockFooterMenuSettings from './BlockFooterMenuSettings';

export interface BlockFooterProps extends BlockProps {
  blockData: BlockData[]
}

function BlockFooter({
  data, isEditing, isTemplate, editHandler, blockData,
}: BlockFooterProps) {
  const props = (data.data as BlockFooterData);

  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    if (isEditing && !isTemplate) {
      setOpen(true);
    }
  };
  const handleClose = () => setOpen(false);

  const handleUpdate = (text: string) => {
    props.title.value = text;
    editHandler(data.id, props);
  };

  const handleMenuDelete = () => {
    props.menus = undefined;
    editHandler(data.id, props);
  };

  const menuItems = useMemo(() => {
    if (props.menus && props.menus?.length > 0) {
      return props.menus?.map((menu: LinkData, index: number) => (
        // eslint-disable-next-line react/no-array-index-key
        <Grid key={index.toString()} item xs="auto">
          {!isEditing && (
            <Link href={menu.linkData.url} target={menu.linkData.openType} rel="noreferrer" underline="hover" color="grey" variant="subtitle1" m="auto">
              {menu.title}
            </Link>
          )}
          {isEditing && (
            <Typography color="grey" variant="subtitle1" m="auto">
              {menu.title}
            </Typography>
          )}
        </Grid>
      ));
    }
    return [];
  }, [props.menus, isEditing]);

  return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
      style={{
        height: 120,
        overflow: 'hidden',
      }}
    >
      {(menuItems.length > 0) && (
        <Grid item xs="auto" sx={{ ...Utils.hoverBorder(isEditing), padding: '12px' }}>
          {isEditing && <CloseButton updateHandler={() => { handleMenuDelete(); }} />}
          <Grid container columnSpacing={2} direction="row" alignItems="center" onClick={handleOpen}>
            {menuItems}
          </Grid>
        </Grid>
      )}
      <BlockFooterMenuSettings
        menuItems={props.menus ?? []}
        open={open}
        closeHandler={(newItems?: LinkData[]) => {
          if (newItems) {
            props.menus = newItems;
            editHandler(data.id, props);
          }
          handleClose();
        }}
        blockData={blockData}
      />
      {props.title && (
        <Grid item sx={Utils.hoverBorder(isEditing)}>
          {isEditing && (
            <CloseButton updateHandler={() => {
              props.title = undefined;
              editHandler(data.id, props);
            }}
            />
          )}
          <EditableText
            text={props.title?.value}
            isEditable={isEditing && !isTemplate}
            updateHandler={handleUpdate}
          />
        </Grid>
      )}

    </Grid>
  );
}

export default BlockFooter;
